<template>
  <div class="padding-10">
    <Toolbar></Toolbar>
    <Table></Table>
  </div>
</template>
<script>
import Toolbar from "../components/cmp/Toolbar.vue";
import Table from "../components/cmp/Table.vue";
export default {
  components: {
    Toolbar,
    Table,
  },
};
</script>

<style></style>
